import React, { memo, useEffect } from "react";
import { Button, useMutation, useNotify } from "react-admin";
import { useForm } from "react-final-form";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";

interface CalculationButtonProps {
  invalid: boolean;
  setResultCalculations: any;
  setIsLoaded: (isLoaded: boolean) => void;
  setIsCalculationButtonClicked: (isLoaded: boolean) => void;
  formData: formCreateStudent;
}

const CalculationButton = ({
  invalid,
  setResultCalculations,
  setIsLoaded,
  setIsCalculationButtonClicked,
  formData,
}: CalculationButtonProps) => {
  const notify = useNotify();
  const formValues = useForm().getState().values;

  const isFixedLocationMonday =
    formValues.isCcaMonday &&
    formValues.dropOffAddressType === "fixed_location";
  const isFixedLocationTuesday =
    formValues.isCcaTuesday &&
    formValues.dropOffAddressType === "fixed_location";
  const isFixedLocationWednesday =
    formValues.isCcaWednesday &&
    formValues.dropOffAddressType === "fixed_location";
  const isFixedLocationThursday =
    formValues.isCcaThursday &&
    formValues.dropOffAddressType === "fixed_location";
  const isFixedLocationFriday =
    formValues.isCcaFriday &&
    formValues.dropOffAddressType === "fixed_location";

  let fixedLocationMondayId = formValues.fixedLocationMondayId;
  let fixedLocationTuesdayId = formValues.fixedLocationTuesdayId;
  let fixedLocationWednesdayId = formValues.fixedLocationWednesdayId;
  let fixedLocationThursdayId = formValues.fixedLocationThursdayId;
  let fixedLocationFridayId = formValues.fixedLocationFridayId;
  if (formValues.isUseOneFixedLocation === true) {
    fixedLocationMondayId = formValues.fixedLocationId;
    fixedLocationTuesdayId = formValues.fixedLocationId;
    fixedLocationWednesdayId = formValues.fixedLocationId;
    fixedLocationThursdayId = formValues.fixedLocationId;
    fixedLocationFridayId = formValues.fixedLocationId;
  }

  useEffect(() => {
    setIsLoaded(false);
    setIsCalculationButtonClicked(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData]);

  const [HandleCalculationCost, { loading }] = useMutation(
    {
      type: "create",
      resource: "CostPreview/registerStudent",
      payload: {
        data: {
          parentId: formValues.parentId,
          schoolId: formValues.schoolId,
          levelId: formValues.levelId,
          levelGroupId: formValues.levelGroupId
            ? formValues.levelGroupId
            : null,
          firstName: formValues.firstName,
          lastName: formValues.lastName,
          gender: formValues.gender,
          macAddress: formValues.macAddress ? formValues.macAddress : null,
          dateOfBirth: formValues.dateOfBirth,
          status: "active",
          uniqueCode: formValues.uniqueCode,

          isRegisterRegularSchedule:
            formValues.scheduleType === "regular" ||
            formValues.scheduleType === "both",
          isRegisterCcaSchedule:
            formValues.scheduleType === "cca" ||
            formValues.scheduleType === "both",

          regularStudentSchedule:
            formValues.scheduleType === "cca"
              ? null
              : {
                  academicYearId: formValues.academicYearId,
                  startedAt: formValues.startedAt,
                  isTaking: true,
                  detail: {
                    lat: formValues.locationData?.LATITUDE,
                    lng: formValues.locationData?.LONGITUDE,
                    street: formValues.street,
                    unitNumber: formValues.unitNumber
                      ? formValues.unitNumber
                      : null,
                    blockNumber: formValues.blockNumber,
                    postalCode: formValues.postalCode,
                    building: formValues.building,
                    isMonday: formValues.isMonday ? true : false,
                    isTuesday: formValues.isTuesday ? true : false,
                    isWednesday: formValues.isWednesday ? true : false,
                    isThursday: formValues.isThursday ? true : false,
                    isFriday: formValues.isFriday ? true : false,
                    isFromSchool:
                      formValues.toAndFrom === "OneWayMorning" ? false : true,
                    isToSchool:
                      formValues.toAndFrom === "OneWayAfternoon" ? false : true,
                  },
                  isApplyStudentSubsidy: formValues.isApplyStudentSubsidy,
                  studentSubsidy: formValues.isApplyStudentSubsidy
                    ? {
                        periodStartDate: formValues.periodStartDate,
                        periodEndDate: formValues.periodEndDate,
                        subsidyPercentage: formValues.subsidyPercentage,
                      }
                    : null,
                },

          ccaStudentSchedule:
            formValues.scheduleType === "regular"
              ? null
              : {
                  ccaAcademicYearId: formValues.ccaAcademicYearId,
                  startedAt: formValues.ccaStartedAt,
                  isTaking: true,
                  dropOffType: formValues.dropOffAddressType,
                  detail: {
                    isMonday: formValues.isCcaMonday,
                    isTuesday: formValues.isCcaTuesday,
                    isWednesday: formValues.isCcaWednesday,
                    isThursday: formValues.isCcaThursday,
                    isFriday: formValues.isCcaFriday,

                    fixedLocationMondayId: isFixedLocationMonday
                      ? fixedLocationMondayId
                      : null,
                    fixedLocationTuesdayId: isFixedLocationTuesday
                      ? fixedLocationTuesdayId
                      : null,
                    fixedLocationWednesdayId: isFixedLocationWednesday
                      ? fixedLocationWednesdayId
                      : null,
                    fixedLocationThursdayId: isFixedLocationThursday
                      ? fixedLocationThursdayId
                      : null,
                    fixedLocationFridayId: isFixedLocationFriday
                      ? fixedLocationFridayId
                      : null,

                    waveMondayId:
                      isFixedLocationMonday && formValues.allowSelectWave
                        ? formValues.waveMondayId
                        : null,
                    waveTuesdayId:
                      isFixedLocationTuesday && formValues.allowSelectWave
                        ? formValues.waveTuesdayId
                        : null,
                    waveWednesdayId:
                      isFixedLocationWednesday && formValues.allowSelectWave
                        ? formValues.waveWednesdayId
                        : null,
                    waveThursdayId:
                      isFixedLocationThursday && formValues.allowSelectWave
                        ? formValues.waveThursdayId
                        : null,
                    waveFridayId:
                      isFixedLocationFriday && formValues.allowSelectWave
                        ? formValues.waveFridayId
                        : null,

                    doorToDoorAddress:
                      formValues.dropOffAddressType === "door_to_door"
                        ? {
                            lat: formValues.ccaLocationData?.LATITUDE,
                            lng: formValues.ccaLocationData?.LONGITUDE,
                            street: formValues.ccaStreet,
                            unitNumber: formValues.ccaUnitNumber
                              ? formValues.ccaUnitNumber
                              : null,
                            blockNumber: formValues.ccaBlockNumber,
                            postalCode: formValues.ccaPostalCode,
                            building: formValues.ccaBuilding,
                          }
                        : null,

                    isFromCca: true,
                  },
                },
        },
      },
    },
    {
      onSuccess: ({ res }) => {
        setResultCalculations(res.json);
        setIsLoaded(true);
        setIsCalculationButtonClicked(true);
      },
      onFailure: (error) => {
        notify(`Failed Calculation Cost, error: ${error.message}`, "warning");
        setResultCalculations([]);
      },
    },
  );

  const CalculationCostButtonStyle = {
    padding: "7px 16px",
  };

  return (
    <Button
      label={loading ? `Loading...` : `Calculation Cost`}
      style={CalculationCostButtonStyle}
      onClick={HandleCalculationCost}
      disabled={invalid}
    >
      <MonetizationOnIcon />
    </Button>
  );
};

export default memo(CalculationButton);
